import { Link } from 'react-router-dom';
import { ArrowUpRight, Files, Network, ScanText } from 'lucide-react';

const SITUATIONS = [
  {
    Icon: Files,
    title: 'The cutover needs a clear boundary.',
    body: 'Close out the SOA work before migration, or plan for what must remain open. Reconcile invoices and document links separately so the team knows what belongs in each environment.',
    to: '/migrations/in-flight-invoice-migration',
    link: 'Plan the invoice cutover',
  },
  {
    Icon: Network,
    title: 'The ERP connection is changing.',
    body: 'A new EBS instance, PeopleSoft, JD Edwards or Fusion Cloud brings its own interfaces, mappings and security. Reconnect the invoice process and prove document access from the target system.',
    to: '/contact?topic=migration',
    link: 'Discuss your ERP integration',
  },
  {
    Icon: ScanText,
    title: 'Recognition needs more attention.',
    body: 'Repeated correction can start with image preparation, reference data or validation. Trace the WFR process through to the ERP handoff and measure the work users still need to do.',
    to: '/support/webcenter-forms-recognition-experts',
    link: 'Look at WFR support',
  },
];

export default function CustomerSituations() {
  return <section className="home-situations" aria-labelledby="situations-heading">
    <div className="container">
      <div className="experience-section-head">
        <div><p className="experience-eyebrow">Where we come in</p><h2 id="situations-heading">The situations behind<br />the project brief.</h2></div>
        <p>You can start with the problem in front of you. We help trace the systems and decisions around it.</p>
      </div>
      <div className="home-situations__grid">
        {SITUATIONS.map(({ Icon, title, body, to, link }) => <article key={title}>
          <Icon size={29} strokeWidth={1.35} aria-hidden="true" />
          <h3>{title}</h3><p>{body}</p>
          <Link className="experience-link" to={to}>{link}<ArrowUpRight size={17} aria-hidden="true" /></Link>
        </article>)}
      </div>
    </div>
  </section>;
}
